(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaccd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaccd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2MyAR", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $cmlvI = parcelRequire("cmlvI");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $cmlvI !== "undefined" && "env" in $cmlvI) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("3qmRS"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("cmlvI", function(module, exports) {
// shim for using process in browser
var $8ff839a7d0ad494d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8ff839a7d0ad494d$var$cachedSetTimeout;
var $8ff839a7d0ad494d$var$cachedClearTimeout;
function $8ff839a7d0ad494d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8ff839a7d0ad494d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        else $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        else $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    }
})();
function $8ff839a7d0ad494d$var$runTimeout(fun) {
    if ($8ff839a7d0ad494d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedSetTimeout === $8ff839a7d0ad494d$var$defaultSetTimout || !$8ff839a7d0ad494d$var$cachedSetTimeout) && setTimeout) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8ff839a7d0ad494d$var$runClearTimeout(marker) {
    if ($8ff839a7d0ad494d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedClearTimeout === $8ff839a7d0ad494d$var$defaultClearTimeout || !$8ff839a7d0ad494d$var$cachedClearTimeout) && clearTimeout) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8ff839a7d0ad494d$var$queue = [];
var $8ff839a7d0ad494d$var$draining = false;
var $8ff839a7d0ad494d$var$currentQueue;
var $8ff839a7d0ad494d$var$queueIndex = -1;
function $8ff839a7d0ad494d$var$cleanUpNextTick() {
    if (!$8ff839a7d0ad494d$var$draining || !$8ff839a7d0ad494d$var$currentQueue) return;
    $8ff839a7d0ad494d$var$draining = false;
    if ($8ff839a7d0ad494d$var$currentQueue.length) $8ff839a7d0ad494d$var$queue = $8ff839a7d0ad494d$var$currentQueue.concat($8ff839a7d0ad494d$var$queue);
    else $8ff839a7d0ad494d$var$queueIndex = -1;
    if ($8ff839a7d0ad494d$var$queue.length) $8ff839a7d0ad494d$var$drainQueue();
}
function $8ff839a7d0ad494d$var$drainQueue() {
    if ($8ff839a7d0ad494d$var$draining) return;
    var timeout = $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$cleanUpNextTick);
    $8ff839a7d0ad494d$var$draining = true;
    var len = $8ff839a7d0ad494d$var$queue.length;
    while(len){
        $8ff839a7d0ad494d$var$currentQueue = $8ff839a7d0ad494d$var$queue;
        $8ff839a7d0ad494d$var$queue = [];
        while(++$8ff839a7d0ad494d$var$queueIndex < len)if ($8ff839a7d0ad494d$var$currentQueue) $8ff839a7d0ad494d$var$currentQueue[$8ff839a7d0ad494d$var$queueIndex].run();
        $8ff839a7d0ad494d$var$queueIndex = -1;
        len = $8ff839a7d0ad494d$var$queue.length;
    }
    $8ff839a7d0ad494d$var$currentQueue = null;
    $8ff839a7d0ad494d$var$draining = false;
    $8ff839a7d0ad494d$var$runClearTimeout(timeout);
}
$8ff839a7d0ad494d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8ff839a7d0ad494d$var$queue.push(new $8ff839a7d0ad494d$var$Item(fun, args));
    if ($8ff839a7d0ad494d$var$queue.length === 1 && !$8ff839a7d0ad494d$var$draining) $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$drainQueue);
};
// v8 likes predictible objects
function $8ff839a7d0ad494d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8ff839a7d0ad494d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8ff839a7d0ad494d$var$process.title = "browser";
$8ff839a7d0ad494d$var$process.browser = true;
$8ff839a7d0ad494d$var$process.env = {};
$8ff839a7d0ad494d$var$process.argv = [];
$8ff839a7d0ad494d$var$process.version = ""; // empty string to avoid regexp issues
$8ff839a7d0ad494d$var$process.versions = {};
function $8ff839a7d0ad494d$var$noop() {}
$8ff839a7d0ad494d$var$process.on = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.addListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.once = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.off = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeAllListeners = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.emit = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependOnceListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.listeners = function(name) {
    return [];
};
$8ff839a7d0ad494d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8ff839a7d0ad494d$var$process.cwd = function() {
    return "/";
};
$8ff839a7d0ad494d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8ff839a7d0ad494d$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3qmRS", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $27e589e8833662c3$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("aS71j"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $27e589e8833662c3$var$setup;

});
parcelRegister("aS71j", function(module, exports) {
/**
 * Helpers.
 */ var $7ea4649ce8770d91$var$s = 1000;
var $7ea4649ce8770d91$var$m = $7ea4649ce8770d91$var$s * 60;
var $7ea4649ce8770d91$var$h = $7ea4649ce8770d91$var$m * 60;
var $7ea4649ce8770d91$var$d = $7ea4649ce8770d91$var$h * 24;
var $7ea4649ce8770d91$var$w = $7ea4649ce8770d91$var$d * 7;
var $7ea4649ce8770d91$var$y = $7ea4649ce8770d91$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $7ea4649ce8770d91$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $7ea4649ce8770d91$var$fmtLong(val) : $7ea4649ce8770d91$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $7ea4649ce8770d91$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $7ea4649ce8770d91$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $7ea4649ce8770d91$var$w;
        case "days":
        case "day":
        case "d":
            return n * $7ea4649ce8770d91$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $7ea4649ce8770d91$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $7ea4649ce8770d91$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $7ea4649ce8770d91$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $7ea4649ce8770d91$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $7ea4649ce8770d91$var$d) return Math.round(ms / $7ea4649ce8770d91$var$d) + "d";
    if (msAbs >= $7ea4649ce8770d91$var$h) return Math.round(ms / $7ea4649ce8770d91$var$h) + "h";
    if (msAbs >= $7ea4649ce8770d91$var$m) return Math.round(ms / $7ea4649ce8770d91$var$m) + "m";
    if (msAbs >= $7ea4649ce8770d91$var$s) return Math.round(ms / $7ea4649ce8770d91$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $7ea4649ce8770d91$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $7ea4649ce8770d91$var$d) return $7ea4649ce8770d91$var$plural(ms, msAbs, $7ea4649ce8770d91$var$d, "day");
    if (msAbs >= $7ea4649ce8770d91$var$h) return $7ea4649ce8770d91$var$plural(ms, msAbs, $7ea4649ce8770d91$var$h, "hour");
    if (msAbs >= $7ea4649ce8770d91$var$m) return $7ea4649ce8770d91$var$plural(ms, msAbs, $7ea4649ce8770d91$var$m, "minute");
    if (msAbs >= $7ea4649ce8770d91$var$s) return $7ea4649ce8770d91$var$plural(ms, msAbs, $7ea4649ce8770d91$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $7ea4649ce8770d91$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});




var $2MyAR = parcelRequire("2MyAR");
var $6199a98db70cef70$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $6199a98db70cef70$var$INFINITY = 1 / 0, $6199a98db70cef70$var$MAX_SAFE_INTEGER = 9007199254740991, $6199a98db70cef70$var$MAX_INTEGER = 1.7976931348623157e+308, $6199a98db70cef70$var$NAN = 0 / 0;
/** Used as references for the maximum length and index of an array. */ var $6199a98db70cef70$var$MAX_ARRAY_LENGTH = 4294967295;
/** `Object#toString` result references. */ var $6199a98db70cef70$var$argsTag = "[object Arguments]", $6199a98db70cef70$var$funcTag = "[object Function]", $6199a98db70cef70$var$genTag = "[object GeneratorFunction]", $6199a98db70cef70$var$mapTag = "[object Map]", $6199a98db70cef70$var$objectTag = "[object Object]", $6199a98db70cef70$var$promiseTag = "[object Promise]", $6199a98db70cef70$var$setTag = "[object Set]", $6199a98db70cef70$var$stringTag = "[object String]", $6199a98db70cef70$var$symbolTag = "[object Symbol]", $6199a98db70cef70$var$weakMapTag = "[object WeakMap]";
var $6199a98db70cef70$var$dataViewTag = "[object DataView]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6199a98db70cef70$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match leading and trailing whitespace. */ var $6199a98db70cef70$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6199a98db70cef70$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6199a98db70cef70$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect host constructors (Safari). */ var $6199a98db70cef70$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect octal string values. */ var $6199a98db70cef70$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $6199a98db70cef70$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to compose unicode character classes. */ var $6199a98db70cef70$var$rsAstralRange = "\ud800-\udfff", $6199a98db70cef70$var$rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", $6199a98db70cef70$var$rsComboSymbolsRange = "\\u20d0-\\u20f0", $6199a98db70cef70$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $6199a98db70cef70$var$rsAstral = "[" + $6199a98db70cef70$var$rsAstralRange + "]", $6199a98db70cef70$var$rsCombo = "[" + $6199a98db70cef70$var$rsComboMarksRange + $6199a98db70cef70$var$rsComboSymbolsRange + "]", $6199a98db70cef70$var$rsFitz = "\ud83c[\udffb-\udfff]", $6199a98db70cef70$var$rsModifier = "(?:" + $6199a98db70cef70$var$rsCombo + "|" + $6199a98db70cef70$var$rsFitz + ")", $6199a98db70cef70$var$rsNonAstral = "[^" + $6199a98db70cef70$var$rsAstralRange + "]", $6199a98db70cef70$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $6199a98db70cef70$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $6199a98db70cef70$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $6199a98db70cef70$var$reOptMod = $6199a98db70cef70$var$rsModifier + "?", $6199a98db70cef70$var$rsOptVar = "[" + $6199a98db70cef70$var$rsVarRange + "]?", $6199a98db70cef70$var$rsOptJoin = "(?:" + $6199a98db70cef70$var$rsZWJ + "(?:" + [
    $6199a98db70cef70$var$rsNonAstral,
    $6199a98db70cef70$var$rsRegional,
    $6199a98db70cef70$var$rsSurrPair
].join("|") + ")" + $6199a98db70cef70$var$rsOptVar + $6199a98db70cef70$var$reOptMod + ")*", $6199a98db70cef70$var$rsSeq = $6199a98db70cef70$var$rsOptVar + $6199a98db70cef70$var$reOptMod + $6199a98db70cef70$var$rsOptJoin, $6199a98db70cef70$var$rsSymbol = "(?:" + [
    $6199a98db70cef70$var$rsNonAstral + $6199a98db70cef70$var$rsCombo + "?",
    $6199a98db70cef70$var$rsCombo,
    $6199a98db70cef70$var$rsRegional,
    $6199a98db70cef70$var$rsSurrPair,
    $6199a98db70cef70$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $6199a98db70cef70$var$reUnicode = RegExp($6199a98db70cef70$var$rsFitz + "(?=" + $6199a98db70cef70$var$rsFitz + ")|" + $6199a98db70cef70$var$rsSymbol + $6199a98db70cef70$var$rsSeq, "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $6199a98db70cef70$var$reHasUnicode = RegExp("[" + $6199a98db70cef70$var$rsZWJ + $6199a98db70cef70$var$rsAstralRange + $6199a98db70cef70$var$rsComboMarksRange + $6199a98db70cef70$var$rsComboSymbolsRange + $6199a98db70cef70$var$rsVarRange + "]");
/** Built-in method references without a dependency on `root`. */ var $6199a98db70cef70$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $6199a98db70cef70$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $6199a98db70cef70$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6199a98db70cef70$var$root = $6199a98db70cef70$var$freeGlobal || $6199a98db70cef70$var$freeSelf || Function("return this")();
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6199a98db70cef70$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $6199a98db70cef70$var$asciiToArray(string) {
    return string.split("");
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $6199a98db70cef70$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $6199a98db70cef70$var$baseValues(object, props) {
    return $6199a98db70cef70$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $6199a98db70cef70$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $6199a98db70cef70$var$hasUnicode(string) {
    return $6199a98db70cef70$var$reHasUnicode.test(string);
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $6199a98db70cef70$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $6199a98db70cef70$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $6199a98db70cef70$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $6199a98db70cef70$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $6199a98db70cef70$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $6199a98db70cef70$var$stringToArray(string) {
    return $6199a98db70cef70$var$hasUnicode(string) ? $6199a98db70cef70$var$unicodeToArray(string) : $6199a98db70cef70$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $6199a98db70cef70$var$unicodeToArray(string) {
    return string.match($6199a98db70cef70$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $6199a98db70cef70$var$funcProto = Function.prototype, $6199a98db70cef70$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $6199a98db70cef70$var$coreJsData = $6199a98db70cef70$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $6199a98db70cef70$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($6199a98db70cef70$var$coreJsData && $6199a98db70cef70$var$coreJsData.keys && $6199a98db70cef70$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $6199a98db70cef70$var$funcToString = $6199a98db70cef70$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6199a98db70cef70$var$hasOwnProperty = $6199a98db70cef70$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6199a98db70cef70$var$objectToString = $6199a98db70cef70$var$objectProto.toString;
/** Used to detect if a method is native. */ var $6199a98db70cef70$var$reIsNative = RegExp("^" + $6199a98db70cef70$var$funcToString.call($6199a98db70cef70$var$hasOwnProperty).replace($6199a98db70cef70$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $6199a98db70cef70$var$Symbol = $6199a98db70cef70$var$root.Symbol, $6199a98db70cef70$var$iteratorSymbol = $6199a98db70cef70$var$Symbol ? $6199a98db70cef70$var$Symbol.iterator : undefined, $6199a98db70cef70$var$propertyIsEnumerable = $6199a98db70cef70$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6199a98db70cef70$var$nativeFloor = Math.floor, $6199a98db70cef70$var$nativeKeys = $6199a98db70cef70$var$overArg(Object.keys, Object), $6199a98db70cef70$var$nativeRandom = Math.random;
/* Built-in method references that are verified to be native. */ var $6199a98db70cef70$var$DataView = $6199a98db70cef70$var$getNative($6199a98db70cef70$var$root, "DataView"), $6199a98db70cef70$var$Map = $6199a98db70cef70$var$getNative($6199a98db70cef70$var$root, "Map"), $6199a98db70cef70$var$Promise = $6199a98db70cef70$var$getNative($6199a98db70cef70$var$root, "Promise"), $6199a98db70cef70$var$Set = $6199a98db70cef70$var$getNative($6199a98db70cef70$var$root, "Set"), $6199a98db70cef70$var$WeakMap = $6199a98db70cef70$var$getNative($6199a98db70cef70$var$root, "WeakMap");
/** Used to detect maps, sets, and weakmaps. */ var $6199a98db70cef70$var$dataViewCtorString = $6199a98db70cef70$var$toSource($6199a98db70cef70$var$DataView), $6199a98db70cef70$var$mapCtorString = $6199a98db70cef70$var$toSource($6199a98db70cef70$var$Map), $6199a98db70cef70$var$promiseCtorString = $6199a98db70cef70$var$toSource($6199a98db70cef70$var$Promise), $6199a98db70cef70$var$setCtorString = $6199a98db70cef70$var$toSource($6199a98db70cef70$var$Set), $6199a98db70cef70$var$weakMapCtorString = $6199a98db70cef70$var$toSource($6199a98db70cef70$var$WeakMap);
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $6199a98db70cef70$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $6199a98db70cef70$var$isArray(value) || $6199a98db70cef70$var$isArguments(value) ? $6199a98db70cef70$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $6199a98db70cef70$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || $6199a98db70cef70$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $6199a98db70cef70$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $6199a98db70cef70$var$baseGetTag(value) {
    return $6199a98db70cef70$var$objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6199a98db70cef70$var$baseIsNative(value) {
    if (!$6199a98db70cef70$var$isObject(value) || $6199a98db70cef70$var$isMasked(value)) return false;
    var pattern = $6199a98db70cef70$var$isFunction(value) || $6199a98db70cef70$var$isHostObject(value) ? $6199a98db70cef70$var$reIsNative : $6199a98db70cef70$var$reIsHostCtor;
    return pattern.test($6199a98db70cef70$var$toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6199a98db70cef70$var$baseKeys(object) {
    if (!$6199a98db70cef70$var$isPrototype(object)) return $6199a98db70cef70$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($6199a98db70cef70$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $6199a98db70cef70$var$baseRandom(lower, upper) {
    return lower + $6199a98db70cef70$var$nativeFloor($6199a98db70cef70$var$nativeRandom() * (upper - lower + 1));
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $6199a98db70cef70$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6199a98db70cef70$var$getNative(object, key) {
    var value = $6199a98db70cef70$var$getValue(object, key);
    return $6199a98db70cef70$var$baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $6199a98db70cef70$var$getTag = $6199a98db70cef70$var$baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ($6199a98db70cef70$var$DataView && $6199a98db70cef70$var$getTag(new $6199a98db70cef70$var$DataView(new ArrayBuffer(1))) != $6199a98db70cef70$var$dataViewTag || $6199a98db70cef70$var$Map && $6199a98db70cef70$var$getTag(new $6199a98db70cef70$var$Map) != $6199a98db70cef70$var$mapTag || $6199a98db70cef70$var$Promise && $6199a98db70cef70$var$getTag($6199a98db70cef70$var$Promise.resolve()) != $6199a98db70cef70$var$promiseTag || $6199a98db70cef70$var$Set && $6199a98db70cef70$var$getTag(new $6199a98db70cef70$var$Set) != $6199a98db70cef70$var$setTag || $6199a98db70cef70$var$WeakMap && $6199a98db70cef70$var$getTag(new $6199a98db70cef70$var$WeakMap) != $6199a98db70cef70$var$weakMapTag) $6199a98db70cef70$var$getTag = function(value) {
    var result = $6199a98db70cef70$var$objectToString.call(value), Ctor = result == $6199a98db70cef70$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $6199a98db70cef70$var$toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case $6199a98db70cef70$var$dataViewCtorString:
            return $6199a98db70cef70$var$dataViewTag;
        case $6199a98db70cef70$var$mapCtorString:
            return $6199a98db70cef70$var$mapTag;
        case $6199a98db70cef70$var$promiseCtorString:
            return $6199a98db70cef70$var$promiseTag;
        case $6199a98db70cef70$var$setCtorString:
            return $6199a98db70cef70$var$setTag;
        case $6199a98db70cef70$var$weakMapCtorString:
            return $6199a98db70cef70$var$weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $6199a98db70cef70$var$isIndex(value, length) {
    length = length == null ? $6199a98db70cef70$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || $6199a98db70cef70$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $6199a98db70cef70$var$isIterateeCall(value, index, object) {
    if (!$6199a98db70cef70$var$isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? $6199a98db70cef70$var$isArrayLike(object) && $6199a98db70cef70$var$isIndex(index, object.length) : type == "string" && index in object) return $6199a98db70cef70$var$eq(object[index], value);
    return false;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6199a98db70cef70$var$isMasked(func) {
    return !!$6199a98db70cef70$var$maskSrcKey && $6199a98db70cef70$var$maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $6199a98db70cef70$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $6199a98db70cef70$var$objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $6199a98db70cef70$var$toSource(func) {
    if (func != null) {
        try {
            return $6199a98db70cef70$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */ function $6199a98db70cef70$var$sampleSize(collection, n, guard) {
    var index = -1, result = $6199a98db70cef70$var$toArray(collection), length = result.length, lastIndex = length - 1;
    if (guard ? $6199a98db70cef70$var$isIterateeCall(collection, n, guard) : n === undefined) n = 1;
    else n = $6199a98db70cef70$var$baseClamp($6199a98db70cef70$var$toInteger(n), 0, length);
    while(++index < n){
        var rand = $6199a98db70cef70$var$baseRandom(index, lastIndex), value = result[rand];
        result[rand] = result[index];
        result[index] = value;
    }
    result.length = n;
    return result;
}
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $6199a98db70cef70$var$shuffle(collection) {
    return $6199a98db70cef70$var$sampleSize(collection, $6199a98db70cef70$var$MAX_ARRAY_LENGTH);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6199a98db70cef70$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $6199a98db70cef70$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $6199a98db70cef70$var$isArrayLikeObject(value) && $6199a98db70cef70$var$hasOwnProperty.call(value, "callee") && (!$6199a98db70cef70$var$propertyIsEnumerable.call(value, "callee") || $6199a98db70cef70$var$objectToString.call(value) == $6199a98db70cef70$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $6199a98db70cef70$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $6199a98db70cef70$var$isArrayLike(value) {
    return value != null && $6199a98db70cef70$var$isLength(value.length) && !$6199a98db70cef70$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $6199a98db70cef70$var$isArrayLikeObject(value) {
    return $6199a98db70cef70$var$isObjectLike(value) && $6199a98db70cef70$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $6199a98db70cef70$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $6199a98db70cef70$var$isObject(value) ? $6199a98db70cef70$var$objectToString.call(value) : "";
    return tag == $6199a98db70cef70$var$funcTag || tag == $6199a98db70cef70$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6199a98db70cef70$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $6199a98db70cef70$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6199a98db70cef70$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6199a98db70cef70$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $6199a98db70cef70$var$isString(value) {
    return typeof value == "string" || !$6199a98db70cef70$var$isArray(value) && $6199a98db70cef70$var$isObjectLike(value) && $6199a98db70cef70$var$objectToString.call(value) == $6199a98db70cef70$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6199a98db70cef70$var$isSymbol(value) {
    return typeof value == "symbol" || $6199a98db70cef70$var$isObjectLike(value) && $6199a98db70cef70$var$objectToString.call(value) == $6199a98db70cef70$var$symbolTag;
}
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $6199a98db70cef70$var$toArray(value) {
    if (!value) return [];
    if ($6199a98db70cef70$var$isArrayLike(value)) return $6199a98db70cef70$var$isString(value) ? $6199a98db70cef70$var$stringToArray(value) : $6199a98db70cef70$var$copyArray(value);
    if ($6199a98db70cef70$var$iteratorSymbol && value[$6199a98db70cef70$var$iteratorSymbol]) return $6199a98db70cef70$var$iteratorToArray(value[$6199a98db70cef70$var$iteratorSymbol]());
    var tag = $6199a98db70cef70$var$getTag(value), func = tag == $6199a98db70cef70$var$mapTag ? $6199a98db70cef70$var$mapToArray : tag == $6199a98db70cef70$var$setTag ? $6199a98db70cef70$var$setToArray : $6199a98db70cef70$var$values;
    return func(value);
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6199a98db70cef70$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $6199a98db70cef70$var$toNumber(value);
    if (value === $6199a98db70cef70$var$INFINITY || value === -$6199a98db70cef70$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6199a98db70cef70$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6199a98db70cef70$var$toInteger(value) {
    var result = $6199a98db70cef70$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6199a98db70cef70$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($6199a98db70cef70$var$isSymbol(value)) return $6199a98db70cef70$var$NAN;
    if ($6199a98db70cef70$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $6199a98db70cef70$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($6199a98db70cef70$var$reTrim, "");
    var isBinary = $6199a98db70cef70$var$reIsBinary.test(value);
    return isBinary || $6199a98db70cef70$var$reIsOctal.test(value) ? $6199a98db70cef70$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6199a98db70cef70$var$reIsBadHex.test(value) ? $6199a98db70cef70$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6199a98db70cef70$var$keys(object) {
    return $6199a98db70cef70$var$isArrayLike(object) ? $6199a98db70cef70$var$arrayLikeKeys(object) : $6199a98db70cef70$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $6199a98db70cef70$var$values(object) {
    return object ? $6199a98db70cef70$var$baseValues(object, $6199a98db70cef70$var$keys(object)) : [];
}
$6199a98db70cef70$exports = $6199a98db70cef70$var$shuffle;


var $909a6c87298a814d$exports = {};
$909a6c87298a814d$exports = function storageAvailable(type) {
    try {
        var storage = window[type], x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
};


var $4461796cdc089526$exports = {};
$4461796cdc089526$exports = JSON.parse('[{"name":"BBC News","articles":[{"title":"How Pakistan helped secure a fragile ceasefire between the US and Iran","url":"https://www.bbc.co.uk/news/articles/cj401qvgg19o"},{"title":"Newlywed wife of US soldier freed by ICE after detention at military base","url":"https://www.bbc.co.uk/news/articles/c98kn1k3nreo"},{"title":"Keir Starmer to visit Middle East after US-Iran ceasefire deal","url":"https://www.bbc.co.uk/news/articles/cj0ve1006g9o"}],"url":"https://www.bbc.co.uk/news"},{"name":"CNN","articles":[{"title":"At the pump with a Gen Z Trump voter | CNN Politics","url":"https://www.cnn.com/2026/04/07/politics/video/gen-z-latino-hispanic-conservatives-gas-prices-war-in-iran-trump-vrtc"},{"title":"Suspect in Gilgo Beach serial killings expected to plead guilty in court today","url":"https://www.cnn.com/2026/04/08/us/rex-heuermann-plea-gilgo-beach-serial-killings"},{"title":"Suspects in attack outside NYC mayor\u2019s residence detailed their plans in notebook and audio recordings, prosecutors say","url":"https://www.cnn.com/2026/04/08/us/gracie-mansion-mamdani-protest-charges-hnk"}],"url":"http://us.cnn.com"},{"name":"Associated Press","articles":[{"title":"Photos: US, Israel and Iran agree to a 2-week ceasefire","url":"https://apnews.com/photo-gallery/photos-iran-israel-us-trump-ceasefire-c7fe7501fb389f48800dd1899851b7dc"},{"title":"Rep. Eric Swalwell vows to constrain ICE if elected California governor","url":"https://apnews.com/article/eric-swalwell-california-governor-newsom-town-hall-a994f116aa87eaa3703e0a21bca7f242"},{"title":"How Trump moved from threats to a ceasefire with Iran","url":"https://apnews.com/article/trump-iran-ceasefire-strait-hormuz-eddbcc14e06a6dcb5c7cc41021120fa8"}],"url":"https://apnews.com/"},{"name":"Bloomberg","articles":[{"title":"Gilts Surge on Lower Oil and Gas Prices After US-Iran Ceasefire","url":"https://www.bloomberg.com/news/articles/2026-04-08/gilts-surge-on-lower-oil-and-gas-prices-after-us-iran-ceasefire"},{"title":"Monte Paschi Fires CEO Lovaglio After Previously Ousting Him","url":"https://www.bloomberg.com/news/articles/2026-04-08/monte-paschi-fires-ceo-lovaglio-after-previously-ousting-him"},{"title":"Dubai Stocks Soar Most in a Decade on Iran War Ceasefire Relief","url":"https://www.bloomberg.com/news/articles/2026-04-08/dubai-stocks-soar-most-in-a-decade-on-iran-war-ceasefire-relief"}],"url":"http://www.bloomberg.com"},{"name":"CBS News","articles":[{"title":"Delta hikes bag check fee by up to $50 as jet fuel prices soar","url":"https://www.cbsnews.com/news/delta-bag-check-fee-jet-fuel-iran-war/"},{"title":"Extended interview: Billy Idol","url":"https://www.cbsnews.com/video/extended-interview-billy-idol/"},{"title":"New DHS chief Markwayne Mullin visits town devastated by Hurricane Helene, promises reforms to FEMA","url":"https://www.cbsnews.com/news/dhs-markwayne-mullin-visits-north-carolina-town-hurricane-helene-reforms-to-fema/"}],"url":"http://www.cbsnews.com"},{"name":"The Huffington Post","articles":[{"title":"This Old Hillary Clinton Tweet About Trump Is Suddenly Very Relevant","url":"https://www.huffpost.com/entry/hillary-clinton-donald-trump-old-tweet_n_69d5e78ae4b0ae5bb24750b5"},{"title":"Wife Of U.S. Soldier Released From Federal Immigration Detention","url":"https://www.huffpost.com/entry/ap-us-immigration-military-bases_n_69d5d647e4b0ae5bb2474b2d"},{"title":"Teen Loses Eye Due To DHS Violence At \u2018No Kings\u2019 Protest, Lawyer Says","url":"https://www.huffpost.com/entry/teen-loses-eye-dhs-agent-no-kings_n_69d5c079e4b06b69686daa64"}],"url":"http://www.huffingtonpost.com"},{"name":"Entertainment Weekly","articles":[{"title":"Jimmy Kimmel skewers Donald Trump for his tough talk about ending a civilization: \'It was the taco Tuesday of all taco Tuesdays\'","url":"https://ew.com/jimmy-kimmel-blasts-donald-trump-for-ending-a-civilization-tough-talk-11945242"},{"title":"\'The Testaments\' stars and creator unpack surprise cameo on \'Handmaid\'s Tale\' sequel premiere","url":"https://ew.com/the-testaments-stars-creator-unpack-surprise-premiere-cameo-11941945"},{"title":"\'The Testaments\' stars and creator break down \'full-body chills\' of \'Handmaid\'s Tale\' sequel premiere","url":"https://ew.com/the-testaments-stars-showrunner-break-down-handmaids-tale-sequel-premiere-11941118"}],"url":"http://www.ew.com"},{"name":"Fox Sports","articles":[{"title":"Best Team To Never Win It All? Brazil&#39;s 1982 Run is a World Cup Top 100 Moment","url":"https://www.foxsports.com/stories/soccer/world-cup-100-best-moments-messi-maradona-ronaldo-pele-mbappe-usa"},{"title":"2026 UFL Power Rankings: Renegades, Storm Leading After Week 2","url":"https://www.foxsports.com/stories/ufl/2026-ufl-power-rankings-renegades-storm-leading-after-week-2"},{"title":"UFL 2026: Full Regular-Season Schedules, Results for All 8 Teams","url":"https://www.foxsports.com/stories/ufl/ufl-2026-full-regular-season-schedule-released-all-8-teams"}],"url":"http://www.foxsports.com"},{"name":"USA Today","articles":[{"title":"Meryl Streep questions Melania Trump\'s \'I really don\'t care\' jacket","url":"https://www.usatoday.com/story/entertainment/celebrities/2026/04/08/meryl-streep-melania-trump-jacket-migrant-children-shelter-texas/89508985007/"},{"title":"Indianapolis politician says shots fired at his home after data center vote","url":"https://www.usatoday.com/story/news/nation/2026/04/08/indianapolis-shots-fired-councilmember-home/89509399007/"},{"title":"Geno Auriemma says Dawn Staley \'deserved better\' in second apology","url":"https://www.usatoday.com/story/sports/ncaaw/2026/04/07/geno-auriemma-dawn-staley-apology-statement/89509779007/"}],"url":"http://www.usatoday.com/news"},{"name":"Google News","articles":[{"title":"Google News","url":"https://news.google.com/rss/articles/CBMid0FVX3lxTE12ZlBDUEJ0dkFaZ21ETlI5V3c4b2ZuM2xfZDR2WVI5RGJDNXJkVmpPTnZVVHR5YkxMTlRCdXlSaWR2cHZDWEFWYmdibFJVdmNVZENDNUJ2NmJaOGdXV1hpTzdWVVFndTJHNFlXTUhUR3hld3VEcGpr"},{"title":"Google News","url":"https://news.google.com/rss/articles/CBMirAFBVV95cUxOQWdMR2RQZEpSSnE3R1BPd1dPVVNvX21tYjhCbFZjcVJRMkozZVFxc3NKUFZid19fMTBZR2Zia3lhbmtLbDlXV21fSERfY3JNYkhEMktlNHZKVXdzaEk4UGlkcDBienpZWjl2OHpwQW9pRnBBaUh2aU5sQlBsVlNkM1FLLVowRXB4WFhWc2g3dmQxYjZzelJzNWhXRlROZjFmN2psUkJWbS1NcHF00gGyAUFVX3lxTE9YUXdxUGhSZ2lHV1p6cHJ1WExBTkFKRlgyQmZuaWRqMGFMTjUtamk2TnI3WGc0eWh5MkpNRTV3bEptbUhFMFdhTmlfZ1lMaFVBbEFseUxDLU9HdVNadkdBUHh1YUVuc1JKTzVJRTNLdXNGbGhYdnFMZlJmSlJfbUhoempHaVB2RjA3bVdFV1dvblpvUnVNRzFubFU0TTlNakk1R0xJTnIwNHFlcmc4VXhkZEE"},{"title":"Republican wins runoff to replace Marjorie Taylor Greene in Congress - The Washington Post","url":"https://access.workspace.google.com/remediate"}],"url":"https://news.google.com"},{"name":"The Wall Street Journal","articles":[{"title":"SpaceX Isn\u2019t Even Public Yet. Investors Are Already Abuzz About a Tesla Merger.","url":"https://www.wsj.com/business/spacex-isnt-even-public-yet-and-investors-are-already-abuzz-about-a-tesla-merger-592b64f6?mod=hp_lead_pos3"},{"title":"Some Republicans Set Their Own Deadline on Iran War. It\u2019s Getting Close.","url":"https://www.wsj.com/politics/some-republicans-set-their-own-deadline-on-iran-war-its-getting-close-29425fa0?mod=WSJ_home_mediumtopper_pos_3"}],"url":"https://www.wsj.com"},{"name":"ESPN","articles":[{"title":"Jayson Tatum preps for return to MSG: \'Just another game\' - ESPN","url":"https://www.espn.com/nba/story/_/id/48426101/jayson-tatum-preps-return-msg-just-another-game"},{"title":"Angels\' Soler, Braves\' Lopez ejected as benches clear in brawl - ESPN","url":"https://www.espn.com/mlb/story/_/id/48426065/angels-soler-braves-lopez-ejected-benches-clear-brawl"},{"title":"Colorado Avalanche clinch Central Division, West\'s top seed - ESPN","url":"https://www.espn.com/nhl/story/_/id/48426007/colorado-avalanche-clinch-central-division-west-top-seed"}],"url":"https://www.espn.com"},{"name":"NBC News","articles":[{"title":"Dozens of Democrats call for Trump\'s removal after his Iran threats","url":"https://www.nbcnews.com/politics/congress/democrats-trump-removal-iran-threats-impeachment-25th-amendment-rcna267194"},{"title":"Sen. Elissa Slotkin takes her Midwest message to Iowa, fueling 2028 speculation","url":"https://www.nbcnews.com/politics/2028-election/sen-elissa-slotkin-takes-midwest-message-iowa-fueling-2028-speculation-rcna266890"},{"title":"Republicans win Georgia race \u2014 but Democrats post largest swing yet in special House elections","url":"https://www.nbcnews.com/politics/elections/republicans-win-georgia-race-democrats-post-largest-swing-yet-special-rcna267192"}],"url":"http://www.nbcnews.com"},{"name":"TechRadar","articles":[{"title":"Own a Kindle from 2012 or earlier? It could be time to upgrade as Amazon\'s officially ending support for very old models","url":"https://www.techradar.com/tablets/ereaders/own-a-kindle-from-2012-or-earlier-it-could-be-time-to-upgrade-as-amazons-officially-ending-support-for-very-old-models"},{"title":"Daredevil: Born Again season 2 episode 4 ending explained \u2014 is [spoiler] really dead in the Disney+ show?","url":"https://www.techradar.com/streaming/disney-plus/daredevil-born-again-season-2-episode-4-ending-explained-is-spoiler-really-dead-in-the-disney-plus-show"},{"title":"Microsoft flags China-based hackers using vicious new \'rapid attack\' zero-days to launch ransomware at targets across the world","url":"https://www.techradar.com/pro/security/microsoft-flags-china-based-hackers-using-vicious-new-rapid-attack-zero-days-to-launch-ransomware-at-targets-across-the-world"}],"url":"https://www.techradar.com"},{"name":"MS Now","articles":[{"title":"Democratic-backed Chris Taylor wins Wisconsin Supreme Court race, growing liberal majority","url":"https://www.ms.now/news/chris-taylor-wins-wisconsin-supreme-court-race-liberal-majority"},{"title":"Trump\u2019s two-week delay is a start. But there\u2019s a big obstacle to a lasting ceasefire.","url":"https://www.ms.now/opinion/trump-iran-deadline-two-week-ceasefire-delay"}],"url":"http://www.ms.now"},{"name":"Politico","articles":[{"title":"Liberal judge cruises to victory in Wisconsin Supreme Court race","url":"https://www.politico.com/news/2026/04/07/chris-taylor-wins-wisconsin-supreme-court-race-00863281"},{"title":"Republican Clay Fuller wins special election to replace Marjorie Taylor Greene","url":"https://www.politico.com/news/2026/04/07/clay-fuller-wins-special-election-marjorie-taylor-greene-00863221"},{"title":"Michigan Senate candidate El-Sayed declines to disavow Hasan Piker\u2019s past comments","url":"https://www.politico.com/news/2026/04/07/el-sayed-hasan-piker-michigan-senate-00863223"}],"url":"https://www.politico.com"},{"name":"The Washington Post","articles":[{"title":"Republican wins runoff to replace Marjorie Taylor Greene in Congress","url":"https://www.washingtonpost.com/politics/2026/04/07/clay-fuller-georgia-special-election-mtg/"}],"url":"https://www.washingtonpost.com"}]');


const $2fd5a75c703b0f49$var$log = (0, (/*@__PURE__*/$parcel$interopDefault($2MyAR)))("lore");
// Delete viewed links that are old to avoid hitting the localStorage limit.
function $2fd5a75c703b0f49$var$pruneViewedLinks() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($909a6c87298a814d$exports)))("localStorage")) return;
    const now = new Date();
    const viewed = JSON.parse(localStorage.getItem("viewed")) || {};
    for(const link in viewed){
        const viewedTime = new Date(viewed[link]);
        const daysOld = (now - viewedTime) / 1000 / 60 / 60 / 24;
        if (daysOld > 7) delete viewed[link];
    }
    $2fd5a75c703b0f49$var$log("Number of viewed links:", Object.keys(viewed).length);
    try {
        localStorage.setItem("viewed", JSON.stringify(viewed));
    } catch (error) {
        localStorage.removeItem("viewed");
    }
}
function $2fd5a75c703b0f49$var$getSourceCard(name, homepageUrl, articles, viewed) {
    const logo = `<h6 class="deep-orange-text darken-2">${name}</h6>`;
    let card = `<div class="col s12 offset-m1 m10 offset-l1 l10">
                    <ul class="collection">
                        <li class="collection-item">
                            <div class="center-align">
                                <a href="${homepageUrl}" target="_blank">
                                   ${logo}
                                </a>
                            </div>
                        </li>`;
    const addedTitles = []; // prevent duplicate links
    for(let i = 0; i < 3 && i < articles.length; i++){
        if (addedTitles.indexOf(articles[i].title) !== -1 || Object.prototype.hasOwnProperty.call(viewed, articles[i].url)) continue;
        addedTitles.push(articles[i].title);
        card += `<li class="collection-item">
                     <a class="article"
                         href="${articles[i].url}"
                         target="_blank">
                         ${articles[i].title}
                     </a>
                 </li>`;
    }
    return addedTitles.length ? `${card}</ul></div>` : null;
}
let $2fd5a75c703b0f49$var$hideViewed = true;
if ((0, (/*@__PURE__*/$parcel$interopDefault($909a6c87298a814d$exports)))("localStorage") && localStorage.getItem("viewOnce") === "off") $2fd5a75c703b0f49$var$hideViewed = false;
else location.search.slice(1).split("&").forEach((pair)=>{
    const [key, value] = pair.split("=");
    if (key === "view-once" && value === "off") $2fd5a75c703b0f49$var$hideViewed = false;
});
if (!$2fd5a75c703b0f49$var$hideViewed) document.getElementById("view-once").checked = false;
else {
    let throttle = false;
    var $2fd5a75c703b0f49$var$checkVisibility = function() {
        if (throttle) return;
        const bottom = window.innerHeight || document.documentElement.clientHeight;
        const articles = document.querySelectorAll("a.article:not(.viewed)");
        if (articles.length === 0) window.removeEventListener("scroll", $2fd5a75c703b0f49$var$checkVisibility);
        const hrefs = {};
        for(let i = 0; i < articles.length; i++){
            const rect = articles[i].getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= bottom) {
                const href = articles[i].getAttribute("href");
                hrefs[href] = new Date().toISOString();
                // To avoid checking it again
                articles[i].classList.add("viewed");
            }
            if (rect.bottom > bottom) break;
        }
        if (Object.keys(hrefs).length) {
            let viewed = {};
            try {
                viewed = JSON.parse(localStorage.getItem("viewed")) || viewed;
            } catch (err) {} // eslint-disable-line no-empty
            Object.assign(viewed, hrefs);
            try {
                localStorage.setItem("viewed", JSON.stringify(viewed));
            } catch (error) {
                localStorage.removeItem("viewed");
            }
        }
        throttle = true;
        setTimeout(function() {
            throttle = false;
        }, 200);
    };
    window.addEventListener("scroll", $2fd5a75c703b0f49$var$checkVisibility);
}
document.getElementById("loading-bar").style.visibility = "visible";
const $2fd5a75c703b0f49$var$headlines = (0, (/*@__PURE__*/$parcel$interopDefault($6199a98db70cef70$exports)))($4461796cdc089526$exports);
let $2fd5a75c703b0f49$var$viewed = {};
if ($2fd5a75c703b0f49$var$hideViewed) try {
    $2fd5a75c703b0f49$var$viewed = JSON.parse(localStorage.getItem("viewed")) || $2fd5a75c703b0f49$var$viewed;
} catch (e) {} // eslint-disable-line no-empty
const $2fd5a75c703b0f49$var$main = document.getElementById("main");
const $2fd5a75c703b0f49$var$endMessage = document.getElementById("end-message");
for (let source of $2fd5a75c703b0f49$var$headlines){
    const card = $2fd5a75c703b0f49$var$getSourceCard(source.name, source.url, source.articles, $2fd5a75c703b0f49$var$viewed);
    if (card) {
        const row = document.createElement("div");
        row.innerHTML = `<div class="row">${card}</div>`;
        $2fd5a75c703b0f49$var$main.insertBefore(row, $2fd5a75c703b0f49$var$endMessage);
    }
}
// Hide the loading bar without causing the rows to move up
// slightly
document.getElementById("loading-bar").style.visibility = "hidden";
// Unhide the end message and footer
$2fd5a75c703b0f49$var$endMessage.classList.remove("hide");
document.getElementById("footer").classList.remove("hide");
if ($2fd5a75c703b0f49$var$hideViewed) $2fd5a75c703b0f49$var$checkVisibility();
$2fd5a75c703b0f49$var$pruneViewedLinks();
document.getElementById("view-once").addEventListener("change", function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($909a6c87298a814d$exports)))("localStorage")) try {
        localStorage.setItem("viewOnce", this.checked ? "on" : "off");
    } catch (error) {
        localStorage.removeItem("viewed");
    }
    else {
        const url = location.origin + (this.checked ? "" : "?view-once=off");
        location.href = url;
    }
});

})();
//# sourceMappingURL=index.b06d3890.js.map
